import React, { PureComponent } from 'react';
import { Icons } from 'sarsaparilla';
import { AlertDefaults, AlertProps } from '../props/alert';

const propTypes = {
  alert: AlertProps
};

export default class Alert extends PureComponent {
  renderIcon() {
    let Comp;

    switch (this.props.alert.level) {
      case 'info':
        Comp = Icons.IconInfo;
        break;
      case 'warning':
        Comp = Icons.IconWarning;
        break;
      case 'success':
        Comp = Icons.IconCheckCircle;
        break;
      default:
        Comp = Icons.IconError;
    }

    return <Comp alt={this.props.alert.title} />;
  }

  render() {
    const { alert } = this.props;

    return (
      <div className={`rec-alert rec-notification-${alert.level}`}>
        <span className="rec-notification-icon">
          {this.renderIcon(alert.level)}
        </span>
        <div className="rec-notification-body">
          <div className="rec-notification-title">{alert.title}</div>
          <p>{alert.message}</p>
        </div>
        <button
          type="button"
          className="rec-notification-close"
          onClick={alert.onClose}>
          <Icons.IconClose alt="Close alert" />
        </button>
      </div>
    );
  }
}

Alert.propTypes = propTypes;
Alert.defaultProps = { alert: AlertDefaults };
